import { Icon, IconName } from '@optimus-web/core';
import { SystemWideBannerContainer, SystemWideBannerTextElement } from './style';
import { SystemWideBannerImportance, SystemWideBannerVariant } from './types';

interface SystemWideBannerProps {
    text: React.ReactNode;
    variant: SystemWideBannerVariant;
    showIcon?: boolean;
    centered?: boolean;
    importance?: SystemWideBannerImportance;
}

const getIcon = (variant: SystemWideBannerVariant) => {
    switch (variant) {
        case 'danger':
            return IconName.AlertCircle;
        case 'info':
            return IconName.Info;
        case 'warning':
            return IconName.Problematic;
    }
};

export const SystemWideBanner = ({
    text,
    variant = 'info',
    showIcon = false,
    centered,
    importance = 'critical',
    ...other
}: SystemWideBannerProps) => (
    <SystemWideBannerContainer variant={variant} centered={centered} importance={importance} {...other}>
        {showIcon && <Icon value={getIcon(variant)} variant="inherit" />}
        <SystemWideBannerTextElement hasIcon={showIcon} variant={variant} importance={importance} centered={centered}>
            {text}
        </SystemWideBannerTextElement>
    </SystemWideBannerContainer>
);
